import RecordingButton from './RecordingButton'

export default RecordingButton
